module.exports = __webpack_public_path__ + "static/media/fundamentos.bbf0bbe1.png";